export default (answers_data, tasks_count, included) => {
  let status = {
    answers: answers_data || {
      'type': 'node--answers', 
      attributes: {}
    },
    completed_tasks: [],
    completed_count: 0,
    all_done: false,
    percentage: 0,
    submitted: false,
    included
  }

  if(status.answers && status.answers.relationships?.field_completed_tasks?.data){
      if(Array.isArray(status.answers.relationships.field_completed_tasks.data) && status.answers.relationships.field_completed_tasks.data.length > 0){
          let set = new Set(status.answers.relationships.field_completed_tasks.data.map((t) => t.id));
          status.completed_tasks = Array.from(set);
      }
  }
  if(status.answers && status.completed_tasks.length > 0){
    status.completed_count = status.completed_tasks.length;
    status.all_done = status.completed_count === tasks_count;
    status.percentage = Math.ceil(status.completed_count * 100 / tasks_count);
  }
  if(status.answers?.attributes?.field_submitted){
    status.submitted = true;
  }
  // console.error('answers were parsed', status);
  return status
}
